import styles from './place.module.scss';
import { IRoom } from '../../../_models/room';
import { makeCourseRequest, useCourseGetRequestHook, useMakeRequestHook } from '../../../requestUtils';
import { ValueFormatterParams } from 'ag-grid-community';
import { useState } from 'react';
import WebkuaTable from '../../../webkua-table/webkua-table';
import { Card, CardContent, Checkbox, CreateHeaders, Divider, ErrorButton, HeaderSizeEnum, Icon, PrimaryButton, SecondaryButton, textHeader } from '@frontend-workspace/react-shared-lib';
import CreateNewPlaceDialog from './create-new-place-dialog/create-new-place-dialog';
import EditPlaceDialog from './edit-place-dialog/edit-place-dialog';
import DeletePlaceDialog from './delete-place-dialog/delete-place-dialog';
import CopyPlaceDialog from './copy-place-dialog/copy-place-dialog';
import PlaceSkeleton from './place-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface PlaceProps { }

export function Place(props: PlaceProps) {
  const { data: rooms, isLoading, getData: getRooms }: { data: IRoom[], isLoading: boolean, getData: () => void } = useCourseGetRequestHook(`Room`, []);

  // Todo:: Bug i BE, viser bare eksisterende kursrom
  //https://focuskursapi.azurewebsites.net/api/Room/UpdateFromSo

  const makeRequest = useMakeRequestHook();
  const { t } = useTranslation();
  const [isNewPlaceOpen, setIsNewPlaceOpen] = useState(false);
  const [editPlace, setEditPlace] = useState<IRoom | undefined>(undefined);
  const [copyPlace, setCopyPlace] = useState<IRoom | undefined>(undefined);
  const [deletePlace, setDeletePlace] = useState<IRoom | undefined>(undefined);
  const [googleMapsUrl, setGoogleMapsUrl] = useState<string>("https://www.google.com/maps/embed/v1/place?key=AIzaSyAWXdfReGPOExNzc3Jl8y54YBnsAnmobCQ&q=Billingstadsletta+19b,Billingstad");

  const toggleNewPlaceOpen = () => setIsNewPlaceOpen(!isNewPlaceOpen);
  const openEditPlaceDialog = (e: any) => setEditPlace(e.data);
  const closeEditPlaceDialog = () => setEditPlace(undefined);
  const openCopyPlaceDialog = (e: any) => setCopyPlace(e.data);
  const closeCopyPlaceDialog = () => setCopyPlace(undefined);
  const openDeletePlaceDialog = (e: any) => setDeletePlace(e.data);
  const closeDeletePlaceDialog = () => setDeletePlace(undefined);

  const editRenderer = (params: ValueFormatterParams) => {
    return (
      <PrimaryButton
        variant="contained"
        size='small'
        onClick={() => openEditPlaceDialog(params)}>
        {t('standard.change')}
      </PrimaryButton>
    );
  };

  const copyRenderer = (params: ValueFormatterParams) => {
    return (
      <PrimaryButton
        variant="outlined"
        size='small'
        onClick={() => openCopyPlaceDialog(params)}>
        {t('standard.copies')}
      </PrimaryButton>
    );
  };

  const deleteRenderer = (params: ValueFormatterParams) => {
    return (
      <ErrorButton
        variant="outlined"
        size='small'
        onClick={() => openDeletePlaceDialog(params)}>
        {t('standard.delete')}
      </ErrorButton>
    );
  };

  const showInGoogleRenderer = (params: ValueFormatterParams) => {
    const baseAddress = "https://www.google.com/maps/embed/v1/place?key=AIzaSyAWXdfReGPOExNzc3Jl8y54YBnsAnmobCQ&q=";
    const mapUrl = baseAddress + params.data.address.replace(" ", "+") + "," + params.data.city + "+Norway";
    const handleClick = () => setGoogleMapsUrl(mapUrl)
    return <Checkbox
      checked={googleMapsUrl === mapUrl}
      onChange={handleClick}
    />
  };

  return (<>
    <div className="d-flex flex-row align-items-end">
      <div className='py-2'>
        <PrimaryButton
          variant="contained"
          onClick={toggleNewPlaceOpen}>
          <Icon className="me-1" fontSize="small">add</Icon>{t('standard.newPlace')}
        </PrimaryButton>
      </div>
    </div>
    {isLoading ? <PlaceSkeleton /> :
      <>
        <WebkuaTable
          data={rooms}
          headers={CreateHeaders([
            textHeader("", t('standard.show'), HeaderSizeEnum.EXTRA_SMALL, { renderer: showInGoogleRenderer }),
            textHeader("name", t('standard.name'), HeaderSizeEnum.EXTRA_LARGE),
            textHeader("seats", t('standard.seats'), HeaderSizeEnum.MEDIUM),
            textHeader("place", t('standard.place'), HeaderSizeEnum.EXTRA_LARGE),
            textHeader("address", t('standard.address'), HeaderSizeEnum.EXTRA_LARGE),
            textHeader("postCode", t('standard.postCode'), HeaderSizeEnum.MEDIUM),
            textHeader("city", t('standard.city'), HeaderSizeEnum.LARGE),
            textHeader("", "", HeaderSizeEnum.MEDIUM, {
              renderer: editRenderer,
              cellStyle: { justifyContent: 'right' },
              headerClass: "ag-right-aligned-header"
            }),
            textHeader("", "", HeaderSizeEnum.MEDIUM, {
              renderer: copyRenderer,
              cellStyle: { justifyContent: 'right' },
              headerClass: "ag-right-aligned-header"
            }),
            textHeader("", "", HeaderSizeEnum.MEDIUM, {
              renderer: deleteRenderer,
              cellStyle: { justifyContent: 'right' },
              headerClass: "ag-right-aligned-header"
            })
          ])}
        />
        <Card
          className='mt-4'
          sx={{ width: 601, height: 451 }}>
          <CardContent
            className='p-0'>
            <iframe
              src={googleMapsUrl}
              width="600"
              height="450"
              allowFullScreen={true}
              loading="lazy"
            />
          </CardContent>
        </Card>
      </>
    }
    {isNewPlaceOpen && <CreateNewPlaceDialog
      onClose={toggleNewPlaceOpen}
      open={!!isNewPlaceOpen}
      refreshData={getRooms}
    />}
    {editPlace && <EditPlaceDialog
      onClose={closeEditPlaceDialog}
      open={!!editPlace}
      refreshData={getRooms}
      roomId={editPlace.id}
    />}
    {copyPlace && <CopyPlaceDialog
      onClose={closeCopyPlaceDialog}
      open={!!copyPlace}
      refreshData={getRooms}
      roomId={copyPlace.id}
    />}
    {deletePlace && <DeletePlaceDialog
      onClose={closeDeletePlaceDialog}
      open={!!deletePlace}
      refreshData={getRooms}
      roomId={deletePlace.id}
    />}
  </>);
}

export default Place;
